import MobileDedect from 'mobile-detect';
import React, {Component} from 'react';
import './App.css';
import AdvertHeader from './Components/Advert-Header';
import AdvertRaces from './Components/Advert-Races';
import AdvertGift from './Components/Advert-Gift';
import AdvertFeature from './Components/Advert-Features';
import AdvertCallAction from './Components/Advert-CallAction';
import AdvertFooter from './Components/Footer';


class App extends Component {
	setCurrentAgent() {
		const mobileDedect = new MobileDedect(window.navigator.userAgent);

		return mobileDedect.phone() || mobileDedect.mobile() || mobileDedect.tablet()
			? 'is-phone is-touch'
			: 'is-desktop is-not-touch'
	}

	render() {
		const appClassNames = "gcAd " + this.setCurrentAgent();

		return (
			<main id="gcAdContent" className={appClassNames} >
				<AdvertHeader gameName={this.props.appText.GameName}
				              chapterName={this.props.appText.ChapterName}
				              fbLink={this.props.appText.fbLink}
				              ytLink={this.props.appText.ytLink}
				              Buttons={this.props.appText.Buttons}/>
				<AdvertRaces RacesList={this.props.appText.Races.RacesList}/>
				<AdvertGift title={this.props.appText.Gift.Title}
				            code={this.props.appText.Gift.Code}
				            redeemButton={this.props.appText.Gift.RedeemButton}
				            link={this.props.appText.Gift.link}
				            ItemsList={this.props.appText.Gift.ItemsList}/>
				<AdvertFeature title={this.props.appText.Features.NewTitle}
				               FeaturesList={this.props.appText.Features.New}
							   type={'new'}
				/>
				<AdvertFeature title={this.props.appText.Features.OldTitle}
				               FeaturesList={this.props.appText.Features.Old}
							   type={'existing'}
				/>
				<AdvertCallAction callActionButton={this.props.appText.CallAction.Button}
				                  link={this.props.appText.CallAction.href}/>
				<AdvertFooter FooterLinks={this.props.appText.Footer.FooterLinks}/>
			</main>
		);
	}
}


export default App;


// WEBPACK FOOTER //
// ./src/App.js